<template>
  <section class="callback-section">
    <div class="callback-section__content-light text-ol-dark-200">
      <h6>
        <slot name="header" />
      </h6>
      <p>
        <slot name="strap" />
      </p>
    </div>
  </section>
</template>

<style scoped>
section.callback-section {
  @apply bg-[unset] w-full max-w-content mt-20;

  div.callback-section__content-light {
    @apply col-span-8 lg:col-span-12 px-5 xs:px-8 md:px-10 py-14 sm:py-10 md:py-12 lg:p-16 rounded-3xl overflow-hidden bg-ol-secondary-20;

    >h6 {
      @apply text-xl sm:text-2xl xl:text-3xl mb-4 xl:mb-6;
    }

    >p {
      @apply text-base lg:text-lg xl:text-xl;
    }
  }
}
</style>